import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { booleanAttribute, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, EventEmitter, inject, Output, ViewChild, NgModule } from '@angular/core';
import { fromEvent } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { collapseMotion } from 'ng-zorro-antd/core/animation';
import * as i1 from 'ng-zorro-antd/core/config';
import { WithConfig } from 'ng-zorro-antd/core/config';
import { NzNoAnimationDirective } from 'ng-zorro-antd/core/no-animation';
import * as i3$1 from 'ng-zorro-antd/core/outlet';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';
import * as i3 from 'ng-zorro-antd/core/services';
import { NzDestroyService } from 'ng-zorro-antd/core/services';
import * as i4 from 'ng-zorro-antd/icon';
import { NzIconModule } from 'ng-zorro-antd/icon';
import * as i2 from '@angular/cdk/bidi';
const _c0 = ["*"];
const _c1 = ["collapseHeader"];
function NzCollapsePanelComponent_Conditional_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const expandedIcon_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzType", expandedIcon_r1 || "right")("nzRotate", ctx_r1.nzActive ? 90 : 0);
  }
}
function NzCollapsePanelComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, NzCollapsePanelComponent_Conditional_2_ng_container_1_Template, 2, 2, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r1.nzExpandedIcon);
  }
}
function NzCollapsePanelComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.nzHeader);
  }
}
function NzCollapsePanelComponent_Conditional_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.nzExtra);
  }
}
function NzCollapsePanelComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, NzCollapsePanelComponent_Conditional_5_ng_container_1_Template, 2, 1, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r1.nzExtra);
  }
}
const NZ_CONFIG_MODULE_NAME$1 = 'collapse';
let NzCollapseComponent = /*#__PURE__*/(() => {
  class NzCollapseComponent {
    constructor(nzConfigService, cdr, directionality, destroy$) {
      this.nzConfigService = nzConfigService;
      this.cdr = cdr;
      this.directionality = directionality;
      this.destroy$ = destroy$;
      this._nzModuleName = NZ_CONFIG_MODULE_NAME$1;
      this.nzAccordion = false;
      this.nzBordered = true;
      this.nzGhost = false;
      this.nzExpandIconPosition = 'start';
      this.dir = 'ltr';
      this.listOfNzCollapsePanelComponent = [];
      this.nzConfigService.getConfigChangeEventForComponent(NZ_CONFIG_MODULE_NAME$1).pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.cdr.markForCheck();
      });
    }
    ngOnInit() {
      this.directionality.change?.pipe(takeUntil(this.destroy$)).subscribe(direction => {
        this.dir = direction;
        this.cdr.detectChanges();
      });
      this.dir = this.directionality.value;
    }
    addPanel(value) {
      this.listOfNzCollapsePanelComponent.push(value);
    }
    removePanel(value) {
      this.listOfNzCollapsePanelComponent.splice(this.listOfNzCollapsePanelComponent.indexOf(value), 1);
    }
    click(collapse) {
      if (this.nzAccordion && !collapse.nzActive) {
        this.listOfNzCollapsePanelComponent.filter(item => item !== collapse).forEach(item => {
          if (item.nzActive) {
            item.nzActive = false;
            item.nzActiveChange.emit(item.nzActive);
            item.markForCheck();
          }
        });
      }
      collapse.nzActive = !collapse.nzActive;
      collapse.nzActiveChange.emit(collapse.nzActive);
    }
    static {
      this.ɵfac = function NzCollapseComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzCollapseComponent)(i0.ɵɵdirectiveInject(i1.NzConfigService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.Directionality), i0.ɵɵdirectiveInject(i3.NzDestroyService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzCollapseComponent,
        selectors: [["nz-collapse"]],
        hostAttrs: [1, "ant-collapse"],
        hostVars: 10,
        hostBindings: function NzCollapseComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("ant-collapse-icon-position-start", ctx.nzExpandIconPosition === "start")("ant-collapse-icon-position-end", ctx.nzExpandIconPosition === "end")("ant-collapse-ghost", ctx.nzGhost)("ant-collapse-borderless", !ctx.nzBordered)("ant-collapse-rtl", ctx.dir === "rtl");
          }
        },
        inputs: {
          nzAccordion: [2, "nzAccordion", "nzAccordion", booleanAttribute],
          nzBordered: [2, "nzBordered", "nzBordered", booleanAttribute],
          nzGhost: [2, "nzGhost", "nzGhost", booleanAttribute],
          nzExpandIconPosition: "nzExpandIconPosition"
        },
        exportAs: ["nzCollapse"],
        standalone: true,
        features: [i0.ɵɵProvidersFeature([NzDestroyService]), i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function NzCollapseComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  __decorate([WithConfig()], NzCollapseComponent.prototype, "nzAccordion", void 0);
  __decorate([WithConfig()], NzCollapseComponent.prototype, "nzBordered", void 0);
  __decorate([WithConfig()], NzCollapseComponent.prototype, "nzGhost", void 0);
  return NzCollapseComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const NZ_CONFIG_MODULE_NAME = 'collapsePanel';
let NzCollapsePanelComponent = /*#__PURE__*/(() => {
  class NzCollapsePanelComponent {
    markForCheck() {
      this.cdr.markForCheck();
    }
    constructor(nzConfigService, ngZone, cdr, destroy$) {
      this.nzConfigService = nzConfigService;
      this.ngZone = ngZone;
      this.cdr = cdr;
      this.destroy$ = destroy$;
      this._nzModuleName = NZ_CONFIG_MODULE_NAME;
      this.nzActive = false;
      this.nzDisabled = false;
      this.nzShowArrow = true;
      this.nzActiveChange = new EventEmitter();
      this.nzCollapseComponent = inject(NzCollapseComponent, {
        host: true
      });
      this.noAnimation = inject(NzNoAnimationDirective, {
        optional: true
      });
      this.nzConfigService.getConfigChangeEventForComponent(NZ_CONFIG_MODULE_NAME).pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.cdr.markForCheck();
      });
    }
    ngOnInit() {
      this.nzCollapseComponent.addPanel(this);
      this.ngZone.runOutsideAngular(() => fromEvent(this.collapseHeader.nativeElement, 'click').pipe(filter(() => !this.nzDisabled), takeUntil(this.destroy$)).subscribe(() => {
        this.ngZone.run(() => {
          this.nzCollapseComponent.click(this);
          this.cdr.markForCheck();
        });
      }));
    }
    ngOnDestroy() {
      this.nzCollapseComponent.removePanel(this);
    }
    static {
      this.ɵfac = function NzCollapsePanelComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzCollapsePanelComponent)(i0.ɵɵdirectiveInject(i1.NzConfigService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i3.NzDestroyService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzCollapsePanelComponent,
        selectors: [["nz-collapse-panel"]],
        viewQuery: function NzCollapsePanelComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c1, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.collapseHeader = _t.first);
          }
        },
        hostAttrs: [1, "ant-collapse-item"],
        hostVars: 6,
        hostBindings: function NzCollapsePanelComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("ant-collapse-no-arrow", !ctx.nzShowArrow)("ant-collapse-item-active", ctx.nzActive)("ant-collapse-item-disabled", ctx.nzDisabled);
          }
        },
        inputs: {
          nzActive: [2, "nzActive", "nzActive", booleanAttribute],
          nzDisabled: [2, "nzDisabled", "nzDisabled", booleanAttribute],
          nzShowArrow: [2, "nzShowArrow", "nzShowArrow", booleanAttribute],
          nzExtra: "nzExtra",
          nzHeader: "nzHeader",
          nzExpandedIcon: "nzExpandedIcon"
        },
        outputs: {
          nzActiveChange: "nzActiveChange"
        },
        exportAs: ["nzCollapsePanel"],
        standalone: true,
        features: [i0.ɵɵProvidersFeature([NzDestroyService]), i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 9,
        vars: 8,
        consts: [["collapseHeader", ""], ["role", "button", 1, "ant-collapse-header"], [1, "ant-collapse-header-text"], [4, "nzStringTemplateOutlet"], [1, "ant-collapse-extra"], [1, "ant-collapse-content"], [1, "ant-collapse-content-box"], ["nz-icon", "", 1, "ant-collapse-arrow", 3, "nzType", "nzRotate"]],
        template: function NzCollapsePanelComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1, 0);
            i0.ɵɵtemplate(2, NzCollapsePanelComponent_Conditional_2_Template, 2, 1, "div");
            i0.ɵɵelementStart(3, "span", 2);
            i0.ɵɵtemplate(4, NzCollapsePanelComponent_ng_container_4_Template, 2, 1, "ng-container", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, NzCollapsePanelComponent_Conditional_5_Template, 2, 1, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 5)(7, "div", 6);
            i0.ɵɵprojection(8);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵattribute("aria-expanded", ctx.nzActive);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.nzShowArrow ? 2 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("nzStringTemplateOutlet", ctx.nzHeader);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.nzExtra ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("ant-collapse-content-active", ctx.nzActive);
            i0.ɵɵproperty("@.disabled", !!(ctx.noAnimation == null ? null : ctx.noAnimation.nzNoAnimation))("@collapseMotion", ctx.nzActive ? "expanded" : "hidden");
          }
        },
        dependencies: [NzOutletModule, i3$1.NzStringTemplateOutletDirective, NzIconModule, i4.NzIconDirective],
        encapsulation: 2,
        data: {
          animation: [collapseMotion]
        },
        changeDetection: 0
      });
    }
  }
  __decorate([WithConfig()], NzCollapsePanelComponent.prototype, "nzShowArrow", void 0);
  return NzCollapsePanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzCollapseModule = /*#__PURE__*/(() => {
  class NzCollapseModule {
    static {
      this.ɵfac = function NzCollapseModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzCollapseModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NzCollapseModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [NzCollapsePanelComponent]
      });
    }
  }
  return NzCollapseModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzCollapseComponent, NzCollapseModule, NzCollapsePanelComponent };
